import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
    selector: 'app-form-errors',
    templateUrl: './form-errors.component.html',
    styleUrls: ['./form-errors.component.scss'],
})
export class FormErrorsComponent implements OnChanges {
    @Input() public errors: ValidationErrors | null;
    @Input() public readOnly = false;
    @Input() public data: string | number;

    @Output() public errorDisplay = new EventEmitter<void>();

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.errors) {
            this.errorDisplay.emit();
        }
    }
}
